import { type ReactElement, useState } from 'react';
import { useIdentityAvailabilityQuery } from '@/entities/user';
import { pendingGuestQuoteStorage } from '@/shared/lib';

/**
 * 로그인·가입 화면의 견적 주문 안내(결정 G11). 링크 화면 [주문하기]로 기억한 견적이 있을 때만 보인다.
 * 무엇을 마치면 견적이 이어지는지(가입 → 이메일 인증 → 휴대폰 본인인증)를 미리 알린다. 연락처가 같아야 한다는 조건은 없다(링크를 가진 고객 계정 누구나).
 * 본인인증 단계는 서버가 쓴다고 확인됐을 때만 말한다 — 불러오는 중·실패면 이메일 인증까지만 안내한다.
 */
export const GuestQuoteOrderHint = (): ReactElement | null => {
  // 화면을 연 순간 한 번 읽는다 — 이 화면에서는 기억이 바뀌지 않는다.
  const [hasPending] = useState(() => pendingGuestQuoteStorage.load() !== null);
  // 기억한 견적이 없으면 안내를 그리지 않으므로 묻지도 않는다.
  const availability = useIdentityAvailabilityQuery({ enabled: hasPending });
  const identityRequired = availability.data?.identityRequired === true;

  if (!hasPending) return null;

  return (
    <section
      aria-label="견적 주문 안내"
      className="mb-8 border-l-2 border-brand-lime bg-muted/70 px-4 py-3 text-[15px] leading-relaxed"
    >
      <p>견적 주문을 이어 가려면 로그인하거나 회원가입해 주세요.</p>
      <p className="mt-1 text-sm text-muted-foreground">
        {identityRequired
          ? '회원가입 뒤 이메일 인증과 휴대폰 본인인증을 마치면 그 견적이 계정에 자동으로 연결돼요.'
          : '회원가입 뒤 이메일 인증을 마치면 그 견적이 계정에 자동으로 연결돼요.'}
      </p>
    </section>
  );
};
